/*@ngInject*/
export default () => (items, find) => {
    if (!find) { return items }
    else { return items.filter(function (elem) {
            return (elem.name + ' ' + elem.surname).toLocaleLowerCase().indexOf(find.toLocaleLowerCase()) !== -1
        });
    }
}
